import React from 'react'
import Footer from './Footer'
import Services from './Services'
import About from './About'
import Mobile from './Mobile'
import ContactDetail from './ContactDetail'
import Contact from './Contact'
import { Box } from '@mui/material'

const LandingPage = () => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <Services />
            <About />
            <Mobile />
            <Contact />
            <ContactDetail />
            <Footer />
        </Box>
    );
};

export default LandingPage;